module.exports = __webpack_public_path__ + "static/img/banner_1.60585e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b2c/banner_1.png
// module id = EVxq
// module chunks = 18